import React from 'react';
import { FormattedMessage } from 'react-intl';
import { observer } from 'mobx-react';
import classnames from 'classnames';

import Styled from 'styled';

import defaultStyles from './review-type-bar-view.scss';

export interface Props {
    styles: typeof defaultStyles;
    changeType: (value: boolean) => void;
    fromSellers: boolean;
}

@observer
class ReviewTypeBarView extends React.Component<Props> {
    render() {
        const { styles, fromSellers, changeType } = this.props;

        return (
            <div className={styles.filterBar}>
                <button
                    className={classnames(styles.headingStyle, styles.typeButtonStyle, {
                        [styles.current]: !fromSellers,
                    })}
                    onClick={() => {
                        changeType(false);
                    }}
                >
                    <FormattedMessage id='BAZAAR_RATINGS_BUYERS' />
                </button>
                <button
                    className={classnames(styles.headingStyle, styles.typeButtonStyle, {
                        [styles.current]: fromSellers,
                    })}
                    onClick={() => {
                        changeType(true);
                    }}
                >
                    <FormattedMessage id='BAZAAR_RATINGS_SELLERS' />
                </button>
            </div>
        );
    }
}

export default Styled(defaultStyles)(ReviewTypeBarView);
